<div class="footer-global">
    <div class="manual-flow-footer__wrapper">
        <div>{{ info() }}</div>
        <priva-group>
            @if (hasCancelBtn()) {
                <button
                    priva-button
                    iconState="left"
                    iconClass="fas fa-xmark"
                    [isDisabled]="!cancelEnabled()"
                    (click)="cancel.emit()"
                    data-test="manual-flow-footer-cancel-button"
                >
                    {{ 'GENERAL.ACTION.CANCEL' | translate }}
                </button>
            }
            <button
                priva-button
                importance="primary"
                iconClass="fas fa-arrow-right"
                iconState="left"
                class="next-btn"
                [isDisabled]="!nextEnabled()"
                (click)="next.emit()"
                data-test="manual-flow-footer-next-button"
            >
                {{ 'GENERAL.ACTION.NEXT' | translate }}
            </button>
        </priva-group>
    </div>
</div>
